import * as React from 'react';
import {CircularProgress, Typography, Box, CircularProgressProps} from '@mui/material';

const MarkProgressCircle = (props: CircularProgressProps & { value: number } & { mark: number } & {numQuestions: number}) => {
    const text = ' out of '
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '0px'
                }}
            >
                <Box>
                    <Typography
                        variant="caption"
                        component="div"
                        color="white"
                        sx={{fontSize: '35px'}}
                    >{props.mark}</Typography>
                </Box>
                <Box>
                    <Typography
                        variant="caption"
                        component="div"
                        color="white"
                        sx={{fontSize: '20px'}}
                    > out of {props.numQuestions}</Typography>
                </Box>
            </Box>
        </Box>
    );
}

export default MarkProgressCircle;